import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	// set './app.js' => 'app'
	const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
	const value = modulesFiles(modulePath)
	modules[moduleName] = value.default
	return modules
}, {})

const store = new Vuex.Store({
	state: {
		// mockBaseUrl: 'http://127.0.0.1:4523/m1/1020899-0-5ccd1d49',
		// aliBaseUrl: 'https://test02.xnzn.net',
		// baseURL: 'https://dev01.xnzn.net/tengyun-api',
		// baseURL: 'https://dev02.xnzn.net/tengyun-api',
		// baseURL: 'https://dev03.xnzn.net/tengyun-api',
		// baseURL: 'https://dev04.xnzn.net/tengyun-api',
		// baseURL: 'https://dev09.xnzn.net/tengyun-api'
		// baseURL: 'https://test01.xnzn.net/tengyun-api',
		// baseURL: 'https://test02.xnzn.net/tengyun-api'
		// baseURL: 'https://test03.xnzn.net/tengyun-api',
		// baseURL: 'https://test04.xnzn.net/tengyun-api',
		baseURL: 'https://test06.xnzn.net/tengyun-api'
		// baseURL: 'http://192.168.124.53:58300' // 毋涵
		// baseURL: "http://120.26.227.190:15068", //江阴霞客镇
		// baseURL: 'http://192.168.2.36:58300' // 郭亚鹏
		// baseURL: 'http://120.26.227.190:15110'
		// baseURL: 'http://192.168.1.223:58300',//陈沈杰
		// baseURL: 'http://120.26.227.190:15058', // url = base url + request url//庞工
		// baseURL: 'http://120.26.227.190:15064'// url = base url + request url//胡工
		// baseURL: "https://yunshitang.xnzn.net", // url = base url + request url//线上
		// baseURL: "http://192.168.124.110:58300",    // 陈民涛
		// baseURL: 'http://192.168.124.36:58300'
		// baseURL: "http://192.168.124.14:58010",    // 刘斌强
		// baseURL: 'http://192.168.2.36:58300' // 李工（李世豪）
		// baseURL: 'http://192.168.124.26:58300', // 李工（李国瑞）
		// baseURL: 'http://120.26.227.190:15034',
		// baseURL: 'http://192.168.0.221:58010',
		// baseURL: 'http://192.168.2.223:58300' // 庞工111
		// baseURL: 'http://192.168.124.222:58300', // 庞工(腾云)
		// baseURL: 'http://192.168.124.115:58300', //刘杨
		// baseURL: 'http://120.26.227.190:15068' // 李国瑞
		// baseURL: "http://172.24.131.3:58010",
		// baseURL: "https://yunshitangtest.xnzn.net" //测试
		// baseURL: "https://120.26.227.190:15064",
		// baseURL: 'http://192.168.2.36:58300' // 刘工（刘斌强）
		// baseURL: "https://alyecs37.xnzn.net",
		// baseURL: "https://alyecs76.xnzn.net",
		// baseURL: "https://ctffyh.ctf.com.cn",
		// baseURL: 'http://192.168.124.26:58300'
		// baseURL: 'https://pay.isimcere.com',//先声
		// baseURL: 'https://njg.xnzn.net',//南京港
		// baseURL: 'https://test01.xnzn.net/tengyun-api',
		// baseURL: 'https://test05.xnzn.net/tengyun-api',
		// baseURL: "http://120.26.227.190:15034"
		// baseURL: "http://120.26.227.190:15116"
		// baseURL: 'http://192.168.124.45:58010', //王工（王云鹏）
		// baseURL: 'http://172.16.1.67:58010',
		// baseURL: 'http://172.25.66.78:58100',
		// baseURL: 'http://192.168.1.215:58100', //胡宽涛120.26.227.190:15071
		// baseURL: 'http://192.168.2.65:58300',
		// baseURL: 'http://120.26.227.190:15071', //localStorage胡宽涛远程
		// baseURL: 'http://120.26.227.190:15062', // 庞工
		// baseURL: "http://120.26.227.190:15118" //本地
		// baseURL: "http://120.26.227.190:15074"
		// baseURL: 'http://192.168.2.65:58300', // 小田儿
		// baseURL: 'http://120.26.227.190:15142'
		// baseURL: "http://120.26.227.190:15064"
		// baseURL: "http://localhost:58100"
	},
	modules,
	getters
})

export default store
